import React, { useMemo } from 'react';
import EmptyRecording from './EmptyRecording';
import EmptyResponse from './EmptyResponse';
import EmptyState, { EmptyStateLayoutType } from './EmptyState';
import EmptyUploadVideo from './EmptyUploadVideo';
import cx from 'classnames';
import {
  FilteredTagsProps,
  getTagNames,
} from '../../Tags/Components/TagFilter/hooks/useFilteredTags';
import { assetUrl } from '~/helpers';

const EmptyRecordingUploadsAndResponses = ({
  tags = [],
  clearTags,
}: FilteredTagsProps) => {
  const handleTagsClearClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    clearTags?.();
  };

  const { title, body } = useMemo(() => {
    const title = `Woops! There are currently no videos or responses under ${getTagNames(
      tags
    )}`;
    const body = (
      <p className='mb-4 text-lg'>
        But don&apos;t fret! Just jump back into{' '}
        <a className='cursor-pointer' onClick={handleTagsClearClick}>
          your library
        </a>{' '}
        and start adding this tag to the relevant assets.
      </p>
    );

    return {
      title,
      body,
    };
  }, [tags]);

  if (tags.length) {
    return (
      <EmptyState
        imageUrl={assetUrl('assets/images/video-library/response.png')}
        title={title}
        body={body}
      />
    );
  }

  const baseClassName = 'border border-solid rounded py-5 px-10';

  return (
    <div className='flex'>
      <EmptyRecording
        layout={EmptyStateLayoutType.block}
        className={baseClassName}
      />
      <EmptyUploadVideo
        layout={EmptyStateLayoutType.block}
        className={cx(baseClassName, 'mx-5')}
      />
      <EmptyResponse
        layout={EmptyStateLayoutType.block}
        className={baseClassName}
      />
    </div>
  );
};

export default EmptyRecordingUploadsAndResponses;
